import { useFlag } from '@unleash/proxy-client-react'
import { useAccountSettings } from './useAccountSettings'

/**
 * EP-67 dual-gate for the parcel text-extraction feature (mirrors the other
 * optional modules per CLAUDE.md): the GLOBAL Unleash flag `parcel_text_extraction`
 * (per-environment runtime switch, no account context) AND the per-account opt-in
 * `account.settings.parcel_text_extraction_enabled` (admin-set, default false).
 *
 * Gate every parcel-extraction affordance (scan page, QuickActionBar entry,
 * photo hint, list button) on this hook — never on `useFlag` alone.
 */
export function useParcelExtractionEnabled(): boolean {
  const flagOn = useFlag('parcel_text_extraction')
  const { data } = useAccountSettings()
  return flagOn && Boolean(data?.settings?.parcel_text_extraction_enabled)
}
